module.exports = __webpack_public_path__ + "img/kv_img_2.fb7699e6.png";